import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  url = environment.url;
  constructor(public http: HttpClient) { }

  toBeBilledCustomerTransactions() {
    return this.http.get(`${this.url}` + '/customer-transactions/toBeBilledCustomerTransactions').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAllAssignedTransactions'))),
    );
  }
  toBeBilledCustomerTransaction(resId) {
    return this.http.get(`${this.url}` + '/customer-transactions/toBeBilledCustomerTransaction/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in backend'))),
    );
  }
  customerPaidTransactions() {
    return this.http.get(`${this.url}` + '/customer-transactions/customerPaidTransactions').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getPaidTransactions'))),
    );
  }
  customerInvoiceInfo(resId) {
    return this.http.get(`${this.url}` + '/customer-transactions/customerInvoiceInfo/' + resId).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting customerInvoiceInfo'))),
    );
  }
  updatePrintOfInvoice(data) {
    return this.http.post(`${this.url}` + '/customer-transactions/updateInvoicePrint', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting updatePrintOfInvoice'))),
    );
  }

  paymentMarkAndCaptureByTReference(data) {
    return this.http.post(`${this.url}` + '/customer-transactions/paymentMarkAndCaptureByTReference', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Failed Transaction'))),
    );
  }
  creditCardPaymentsOfTransaction(data) {
    return this.http.post(`${this.url}` + '/customer-transactions/additionalPaymentByCC', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Failed Transaction'))),
    );
  }
  manualClosurePaymentForCustomer(data) {
    return this.http.post(`${this.url}` + '/customer-transactions/manualPaymentUpdateForCustomer', data).pipe(tap(res => res),
      catchError(err => throwError(new Error(err))),
    );
  }

}
